import { PredefinedPrice } from '@search/vtbeco-frontend-core/view/filters/types/PredefinedPrice';
import { sellFlatPricesPerAllSquareMsk, sellFlatPricesPerMeterMskMo, sellFlatPricesPerMeterSpbLo, sellFlatPricesPerAllSquareSpb, rentFlatPricesMsk, rentFlatPricesSpb, mortgagePaymentMskAndSpb, mortgagePaymentRegions } from '../../../view/filters/helpers/priceHelper';
import { ClassifiedFilterCollection } from './ClassifiedFilterCollection';

export class ClassifiedFilterUi {
    static getPricePreset(filters: ClassifiedFilterCollection): PredefinedPrice[] | number[] {
        const isSellFlatByAllSquare =
            filters.isSellFilterActive() &&
            filters.isFlatFilterActive() &&
            filters.isPricePerAllSquare();

        const isSellFlatPerMeterSquare =
            filters.isSellFilterActive() &&
            filters.isFlatFilterActive() &&
            filters.isPricePerMeterSquare();

        const isMortgagePayment =
            filters.isSellFilterActive() &&
            filters.isMortgagePayment();

        const isRentFlat =
            filters.isRentFilterActive() &&
            filters.isFlatFilterActive();

        if (isMortgagePayment) {
            if (filters.isRegionMskOrMo() || filters.isRegionSpbOrLo()) return mortgagePaymentMskAndSpb;
            return mortgagePaymentRegions;
        }

        if (isSellFlatByAllSquare) {
            if (filters.isRegionMskOrMo()) {
                return sellFlatPricesPerAllSquareMsk;
            } else if (filters.isRegionSpbOrLo()) {
                return sellFlatPricesPerAllSquareSpb;
            }
        }

        if (isSellFlatPerMeterSquare) {
            if (filters.isRegionMskOrMo()) {
                return sellFlatPricesPerMeterMskMo;
            } else if (filters.isRegionSpbOrLo()) {
                return sellFlatPricesPerMeterSpbLo;
            }
        }

        if (isRentFlat) {
            if (filters.isRegionMskOrMo()) {
                return rentFlatPricesMsk;
            } else if (filters.isRegionSpbOrLo()) {
                return rentFlatPricesSpb;
            }
        }

        return [];
    }
}
